/**
 * Search Icon Component
 *
 * Magnifying glass search icon with multiple states and sizes.
 * Figma: Search Icon (Node: 895:23489)
 *
 * States: Default, Active, Small (Inactive/Active), Large (Inactive/Active)
 * Sizes: Default (17.495px), Small (14px), Large (20px)
 */
"use client";

import Image from "next/image";

interface SearchIconProps {
  size?: "default" | "small" | "large";
  active?: boolean;
  className?: string;
  onClick?: () => void;
}

export function SearchIcon({
  size = "default",
  active = false,
  className = "",
  onClick,
}: SearchIconProps) {
  const sizeMap = {
    default: 17.495,
    small: 14,
    large: 20,
  };

  const iconSize = sizeMap[size];
  const iconSrc = active ? "/icons/search-white.svg" : "/icons/search.svg";

  return (
    <button
      onClick={onClick}
      className={`relative flex items-center justify-center transition-opacity hover:opacity-70 ${className}`}
      style={{
        width: `${iconSize}px`,
        height: `${iconSize}px`,
      }}
      aria-label="Search"
    >
      <Image src={iconSrc} alt="" width={iconSize} height={iconSize} />
    </button>
  );
}
